const BASE_VALUE = 16;

export const TIMELINE_CATEGORY_ROW_BASE_VALUE = 3.75;
export const TIMELINE_CATEGORY_ROW_HEIGHT = `${TIMELINE_CATEGORY_ROW_BASE_VALUE}rem`;

export const TIMELINE_Y_AXIS_COLUMN_PADDING_TOP_BASE_VALUE = 1.125;
export const TIMELINE_Y_AXIS_COLUMN_PADDING_TOP = `${TIMELINE_Y_AXIS_COLUMN_PADDING_TOP_BASE_VALUE}rem`;

export const TIMELINE_CHART_BELOW_PLOT_STUB_BASE_VALUE = 1;
export const TIMELINE_CHART_BELOW_PLOT_STUB_HEIGHT = `${TIMELINE_CHART_BELOW_PLOT_STUB_BASE_VALUE}rem`;

export const TIMELINE_CHART_X_AXIS_BASE_VALUE = 100;
export const TIMELINE_CHART_X_AXIS_COEFFICIENT =
  TIMELINE_CHART_X_AXIS_BASE_VALUE / BASE_VALUE;
export const TIMELINE_CHART_X_AXIS_HEIGHT = `${TIMELINE_CHART_X_AXIS_COEFFICIENT}rem`;

export const TIMELINE_CHART_MIN_HEIGHT = 544;
export const TIMELINE_CHART_MIN_COEFFICIENT =
  TIMELINE_CHART_MIN_HEIGHT / BASE_VALUE;
export const TIMELINE_CHART_MIN_HEIGHT_REM = `${TIMELINE_CHART_MIN_COEFFICIENT}rem`;
export const SERIES_COLUMN_HEIGHT = 25;
export const SERIES_CORNER_RADIUS = 5;
export const SERIES_STROKE_OPACITY = 0.1;
export const TIMELINE_SERIES_INFO_FILL_OPACITY = 0.2;
export const NOW_LINE_STROKE_WIDTH = 1.5;
export const NOW_LINE_DASH_SEGMENT = 10;
export const NOW_LINE_DASH_GAP = 6;
export const NOW_LINE_DASH_ARRAY = [NOW_LINE_DASH_SEGMENT, NOW_LINE_DASH_GAP];
export const TOOLTIP_BACKGROUND_OPACITY = 0.75;
export const TIMELINE_FONT_SIZE = '0.875rem';
export const TIMELINE_X_AXIS_LABEL_WIDTH = 120;
export const Y_AXIS_LABEL_MAX_WIDTH = 360;
export const TIMELINE_PLOT_BOTTOM_DIVIDER_HEIGHT = 1;
export const TIMELINE_PLOT_BOTTOM_DIVIDER_X_PERCENT = 50;
export const TIMELINE_PLOT_BOTTOM_DIVIDER_Y_PERCENT = 100;
export const TIMELINE_PLOT_BOTTOM_DIVIDER_WIDTH_PERCENT = 100;
export const TIMELINE_Y_AXIS_MIN_GRID_DISTANCE = 1;

export const TIMELINE_CHART_BOTTOM_PADDING = 20;

export const AMCHARTS_ROOT_FRAME_ENDED_EVENT = 'frameended';
export const TIMELINE_NOW_LINE_UPDATE_INTERVAL_MS = 60_000;

export enum TIMELINE_MODE {
  DAY = 'day',
  MONTH = 'month',
  WEEK = 'week',
}

export const TIMELINE_MODE_ORDERED: TIMELINE_MODE[] = [
  TIMELINE_MODE.DAY,
  TIMELINE_MODE.WEEK,
  TIMELINE_MODE.MONTH,
];

export const TIMELINE_MODE_LABELS: Record<TIMELINE_MODE, string> = {
  [TIMELINE_MODE.DAY]: 'common.timeline.mode.label.day',
  [TIMELINE_MODE.WEEK]: 'common.timeline.mode.label.week',
  [TIMELINE_MODE.MONTH]: 'common.timeline.mode.label.month',
};

export enum TIMELINE_PERIOD_DIRECTION {
  NEXT = 'next',
  PREVIOUS = 'previous',
}

export enum WEEK_DAY_INDEX {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}
